export function MenuWorkScheduleIcon() {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        y='36'
        width='36'
        height='36'
        rx='18'
        transform='rotate(-90 0 36)'
        fill='#021542'
      />
      <path
        d='M12 12L14 10M14 10L12 8M14 10H12C9.79086 10 8 11.7909 8 14M24 24L22 26M22 26L24 28M22 26H24C26.2091 26 28 24.2091 28 22M16.189 12.5C16.8551 9.91216 19.2042 8 22 8C25.3137 8 28 10.6863 28 14C28 16.7957 26.0879 19.1449 23.5001 19.811M20 22C20 25.3137 17.3137 28 14 28C10.6863 28 8 25.3137 8 22C8 18.6863 10.6863 16 14 16C17.3137 16 20 18.6863 20 22Z'
        stroke='#E4ECFF'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
